/**
 * 描述：评价系统 ----评价设置 接口管理
 * Created by 钱磊
 * 时间：2022-5-19 14:24:59
 */
 import request from '../../request.js'
 /**
* 描述：评价规则保存
* 接口管理员：赵建强
* 参数： 
{
    sname:'',          // 规则名称
    applyBus:'',       // 应用业务（码表
    assItems:'',       // 评价项目（码表拼接字符串）
    singleScore:'',    // 单项分值
    totalScore:'',     // 单项总分
    ruleStatus:'',     //启用状态 0：禁用 1：启用
}
*/
export const saveAssessRule = function (data) {
  return request({
      url: '/ngsAssess/saveAssessRule',
      method: 'post',
      requestConfig: {
          hideLoading: true
      },
      data
  })
}
 /**
* 描述：评价规则分页列表
* 接口管理员：赵建强
* 参数： 
{
    sname:'',          // 规则名称
    applyBus:'',       // 应用业务（码表）
    size:10,          // 当前每页条数
    current:1,        // 当前页码
}
*/
export const getRulePageList = function (data) {
  return request({
      url: '/ngsAssess/selAssessRulePageList',
      method: 'post',
      requestConfig: {
          hideLoading: true
      },
      data
  })
}

 /**
* 描述：评价规则删除
* 接口管理员：赵建强
* 参数： 
{
    id:'',          // ID
}
*/
export const delAssessRule = function (data) {
  return request({
      url: '/ngsAssess/delAssessRule',
      method: 'post',
      requestConfig: {
          hideLoading: true
      },
      data
  })
}

 /**
* 描述：修改评价规则状态
* 接口管理员：赵建强
* 参数： 
{
    id:'',          // ID
    ruleStatus:'',          // 启用状态 0：禁用 1：启用
}
*/
export const updateStatus = function (data) {
  return request({
      url: '/ngsAssess/updateStatus',
      method: 'post',
      requestConfig: {
          hideLoading: true
      },
      data
  })
}